import {useQuery} from '@apollo/client'
import {CHECK_US_LOCATION} from '../gql/queries/authQuery'

interface ICurrentLocationResult {
  isUsLocation: boolean
  currentLocation: string
}

export const useCurrentLocation = () => {
  const {data, loading} = useQuery<ICurrentLocationResult>(CHECK_US_LOCATION, {
    fetchPolicy: 'cache-first',
  })

  return {
    isUsLocation: data?.isUsLocation ?? true,
    currentLocation: data?.currentLocation ?? 'Unknown',
    loading,
  }
}
